import { RefTypeBalise } from './ref-type-balise.model';
import { RefCategorie } from './ref-categorie.model';
import { RefTypeFichier } from './ref-type-fichier.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class ReferencesEdition {
    static jsonMap = {
        refCategorieList: { key: 'refCategorieList', converter: new (ArrayClassConverterFactory.build(RefCategorie))(), optional: true, default: () => [] },
        refTypeBaliseList: { key: 'refTypeBaliseList', converter: new (ArrayClassConverterFactory.build(RefTypeBalise))(), optional: true, default: () => [] },
        refTypeFichierList: {
            key: 'refTypeFichierList',
            converter: new (ArrayClassConverterFactory.build(RefTypeFichier))(),
            optional: true,
            default: () => []
        }
    };

    refCategorieList: RefCategorie[];
    refTypeBaliseList: RefTypeBalise[];
    refTypeFichierList: RefTypeFichier[];

    getRefCategorieList() {
        return this.refCategorieList;
    }

    getRefTypeBaliseList() {
        return this.refTypeBaliseList;
    }
}
